<template>
  <el-container class="box">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicFoldSearch :searchList='searchList' v-on:getSearchObj='getSearchObj' :rightEventList='rightEventList'
        @rightFunc='rightFunc' />
    </div>
    <el-main class="bottom-tabel">
      <el-table :data="tableData" :header-cell-style="{
			  background:'#FAFAFA',
			  fontWeight: 'bold',
			  color: '#333333',
			  fontSize:'14px'
			}">

        <el-table-column align="center" min-width="110px" prop="platformName" label="互医机构名称">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.platformName"
              :disabled="scope.row.platformName&&scope.row.platformName.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.platformName | filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="code" label="机构编号">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.code" :disabled="scope.row.code&&scope.row.code.length>6?false:true"
              placement="top">
              <span class="fieldWidth">{{ scope.row.code|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="name" label="机构名称">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.name" :disabled="scope.row.name&&scope.row.name.length>7?false:true"
              placement="top">
              <span class="fieldWidth">{{ scope.row.name|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="orgServerType" label="机构服务">
          <template slot-scope="scope">
            <span v-if="scope.row.orgServerType==1">全病程管理</span>
            <span v-if="scope.row.orgServerType==2">上门管理</span>
            <span v-if="scope.row.orgServerType==3">全病程+服务管理</span>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="loginUsername" label="登录名">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.loginUsername"
              :disabled="scope.row.loginUsername&&scope.row.loginUsername.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.loginUsername|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="orgPrincipal" label="负责人">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.orgPrincipal" placement="top">
              <span class="fieldWidth">{{scope.row.orgPrincipal}}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="address" label="机构地址">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.address"
              :disabled="scope.row.address&&scope.row.address.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.address|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="serverTel" label="客服电话">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.serverTel"
              :disabled="scope.row.serverTel&&scope.row.serverTel.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.serverTel | filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="110px" prop="enterEndTime" label="入驻截止时间">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.enterEndTime"
              :disabled="scope.row.enterEndTime && scope.row.enterEndTime.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.enterEndTime|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="description" label="机构描述">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.description"
              :disabled="scope.row.description && scope.row.description.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.description|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="disabled" label="是否启用">
          <template slot-scope="scope">
            <span class="fieldWidth" v-if="scope.row.state!=0">{{ scope.row.disabled?'否':"是"}}</span>
            <span class="fieldWidth" v-else>
              --
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="100px" prop="state" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state==0">草稿</span>
            <span v-if="scope.row.state==1">即将过期</span>
            <span v-if="scope.row.state==2">入驻</span>
            <span v-if="scope.row.state==3">已过期</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" width="180" label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.state!==0">
              <el-button @click="checkDetail(scope.row)" type="text" size="small">
                查看
              </el-button>

              <el-button :disabled="!scope.row.code" @click="resetPassword(scope.row)" type="text" size="small">
                重置密码
              </el-button>
              <el-button :disabled="!scope.row.code" @click="qrcodeShow(scope.row)" type="text"
                size="small">二维码</el-button>
              <el-button v-if="yanqi(scope.row.enterEndTime)" @click="NowApproval(scope.row)" type="text"
                size="small">立即延期</el-button>
              <el-button v-if="chongzhu(scope.row.enterEndTime)" @click="NowApproval(scope.row)" type="text"
                size="small">重新入驻</el-button>
            </div>
            <div v-else>
              <el-button @click="checkDetail(scope.row)" type="text" size="small">
                查看
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchParams.current" :page-size="searchParams.size"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-main>

    <el-dialog :close-on-click-modal="false" title="查看二维码" v-if="dialogFormVisible" key="100" center width="650px"
      :visible.sync="dialogFormVisible">
      <img style="width: 100%;" :src="qrcodeUrl">
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="延期时间" v-if="dialogFormVisible1" key="101" width="500px"
      :visible.sync="dialogFormVisible1">
      <el-date-picker v-model="enterEndTime" type="date" placeholder="选择日期" format="yyyy年MM月dd日"
        value-format="yyyy-MM-dd">
      </el-date-picker>
      <div class="dialog-footer">
        <el-button @click="CloseDialogFormVisible1">取消</el-button>
        <el-button type="primary" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import {
  institutionResetPassword,
  getHospitalQrCode,
  setEnterEndTime
} from "./api";
import local from "@/utils/local.js";
// 医院
import {
  api_hospital,
} from "@/api/org.js";
export default {
  data() {
    return {
      breadList: [{ name: "机构组织" }, { name: "机构管理" }],
      rightEventList: [{ eventName: "新增机构", eventValue: 1 }],
      searchList: [
        {
          label: "机构名称",
          value: 1,
          paramName: "name",
          inputType: "input"
        },
        {
          label: "登录名",
          value: 2,
          paramName: "loginUsername",
          inputType: "input"
        },
        {
          label: "入驻截止时间",
          value: 3,
          paramName: "timeRange",
          inputType: "datetimerange",
          paramstartTime: "enterStartTime",
          paramEndTime: "enterEndTime"
        },
        {
          label: "状态",
          value: 4,
          paramName: "state",
          inputType: "select",
          optionData: [
            { value: 0, label: "草稿" },
            { value: 1, label: "即将过期" },
            { value: 2, label: "入驻" },
            { value: 3, label: "已过期" }
          ]
        },
        {
          label: "机构地址",
          value: 5,
          paramName: "address",
          inputType: "input"
        },
        {
          label: "是否启用",
          value: 6,
          paramName: "disabled",
          inputType: "select",
          optionData: [
            { value: true, label: "否" },
            { value: false, label: "是" }
          ]
        },
        {
          label: "机构类型",
          value: 7,
          paramName: "orgServerType",
          inputType: "select",
          optionData: [
            {
              label: "全病程管理",
              value: "1"
            },
            {
              label: "医护上门",
              value: "2"
            },
            {
              label: "全病程+医护上门",
              value: "3"
            }
          ]
        }
      ],
      searchParams: {
        current: 1,
        size: 10
      },
      qrcodeUrl: "",
      userid: "",
      form: {
        description: "",
        name: "",
        diseaseId: "",
        subDiseaseIds: [],
        typeIds: [],
        diseaseName: ""
      },
      dialogFormVisible: false,
      dialogFormVisible1: false,
      total: 0,
      tableData: [],
      decisionType: [],
      diseaseListData: [],
      enterEndTime: "",
      dataId: "",
      formRule: {
        name: [
          {
            required: true,
            message: "请输入机构名称",
            trigger: "blur"
          }
        ],
        typeIds: [
          {
            required: true,
            message: "请选择分类",
            trigger: "change"
          }
        ],
        diseaseId: [
          {
            required: true,
            message: "请选择主适配病种",
            trigger: "change"
          }
        ]
      },
      hospitalList: [
        {
          label: "机构名称",
          value: 1
        },
        {
          label: "登录名",
          value: 2
        },
        {
          label: "入驻截止时间",
          value: 3
        },
        {
          label: "状态",
          value: 4
        },
        {
          label: "机构地址",
          value: 5
        },
        {
          label: "是否启用",
          value: 6
        },
        {
          label: "机构服务",
          value: 7
        }
      ]
    };
  },
  computed: {},
  created() {
    this.userid = local.get("userid");
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.init();
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.$router.push({ path: "/Organization/addInstitution" });
      }
    },
    saveSort() {
      setEnterEndTime({
        id: this.dataId,
        enterEndTime: this.enterEndTime
      }).then(res => {
        this.$message.success("操作成功");
        this.dialogFormVisible1 = false;
        this.enterEndTime = "";
        this.init();
      });
    },
    CloseDialogFormVisible1() {
      this.dialogFormVisible1 = false;
      this.enterEndTime = "";
    },
    qrcodeShow(data) {
      getHospitalQrCode({ hospitalId: data.id }).then(res => {
        this.qrcodeUrl = res.data.wxQrcodeUrl;
        this.dialogFormVisible = true;
      });
    },
    resetPassword(data) {
      this.$confirm("是否确认重置密码，重置后密码为Pass@1234", "确认信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          institutionResetPassword(data.salesPrincipalUserId).then(res => {
            this.$message.success("重置成功");
          });
        })
        .catch(() => {});
    },
    enterOrganization() {},
    yanqi(time) {
      let timeGet = new Date(time).getTime();
      let nowTime = new Date().getTime();
      let timeCha = timeGet - nowTime;
      if (timeCha > 0 && timeCha < 2592000000) {
        return true;
      } else {
        return false;
      }
    },
    chongzhu(time) {
      let timeGet = new Date(time + " 23:59:59").getTime();
      let nowTime = new Date().getTime();
      let timeCha = timeGet - nowTime;
      if (timeCha < -86400000) {
        return true;
      } else {
        return false;
      }
    },
    checkDetail(data, t) {
      this.$router.push({
        path: "/Organization/updateInstitution",
        query: {
          id: data.id,
          type: 1,
          t: t
        }
      });
    },
    //存决策树id及区分模板编辑||患者编辑页面
    setDecisionTreeObj(id) {
      let obj = {
        pageName: "templatePage", //模板编辑：templatePage 患者编辑：patientPage
        decisionTreeId: id
      };
      localStorage.setItem("decisionTreeObj", JSON.stringify(obj));
    },
    NowApproval(data) {
      this.dataId = data.id;
      this.dialogFormVisible1 = true;
    },
    publishClick(data) {
      if (data.publishStatus) {
        decisionTreePublish({
          decisionTreeId: data.id,
          isPublish: false
        }).then(res => {
          this.$message.success("操作成功");
          this.init();
        });
      } else {
        decisionTreePublish({
          decisionTreeId: data.id,
          isPublish: true
        }).then(res => {
          this.$message.success("操作成功");
          this.init();
        });
      }
    },
    Approval(data) {
      if (data.status == 2 || data.status == 3) {
        cancelApproval(data.id).then(res => {
          this.$message.success("操作成功");
          this.init();
        });
      } else {
        decisionTreeSubmitApproval({
          id: data.id
        }).then(res => {
          this.$message.success("操作成功");
          this.init();
        });
      }
    },
    saveDescription() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let obj;
          if (this.form.subDiseaseIds.length) {
            let subArr = [];
            this.diseaseListData.forEach(item => {
              this.form.subDiseaseIds.forEach(v => {
                if (item.id === v) {
                  subArr.push(item.suborderName);
                }
              });
            });
            obj = {
              description: this.form.description,
              name: this.form.name,
              diseaseId: this.form.diseaseId,
              diseaseName: this.form.diseaseName,
              subDiseaseIds: this.form.subDiseaseIds.join(","),
              subDiseaseNames: subArr.join(","),
              typeIds: this.form.typeIds.join(",")
            };
          } else {
            obj = {
              description: this.form.description,
              name: this.form.name,
              diseaseId: this.form.diseaseId,
              diseaseName: this.form.diseaseName,
              typeIds: this.form.typeIds.join(",")
            };
          }
          decisionTreeInsertReturnId(obj).then(res => {
            this.$message.success("操作成功");
            this.setDecisionTreeObj(res.data);
            this.$router.push({
              path: "/decisionMain",
              query: {
                decisionTreeId: res.data
              }
            });

            this.resetForm();
            this.dialogFormVisible = false;
            this.init();
          });
        } else {
          return false;
        }
      });
    },
    returnText(id, arr, nowKey, Key) {},
    diseaseTypeChange1(v) {
      this.listQuery1.diseaseName = "";
      for (var i = 0; i < this.diseaseListData.length; i++) {
        if (v == this.diseaseListData[i].id) {
          this.listQuery1.diseaseName = this.diseaseListData[i].suborderName;
        }
      }
    },
    diseaseTypeChange(v) {
      this.form.diseaseName = "";
      for (var i = 0; i < this.diseaseListData.length; i++) {
        if (v == this.diseaseListData[i].id) {
          this.form.diseaseName = this.diseaseListData[i].suborderName;
        }
      }
    },
    init() {
      this.searchParams.companyId =
        this.$store.state.companyId || local.get("companyId");
      this.searchParams.platformId =
        this.$store.state.platformId || local.get("platformId");
      api_hospital(this.searchParams).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    resetForm() {
      this.form.typeIds = [];
      this.form.subDiseaseIds = [];
      this.$refs["ruleForm"].resetFields();
    },
    addInfo() {
      this.$router.push({ path: "/Organization/addInstitution" });
    },
    handleSizeChange(val) {
      this.searchParams.size = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.searchParams.current = val;
      this.init();
    }
  }
};
</script>

<style scoped lang="less">
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.a-tag {
  border-radius: 11px;
  margin-right: 15px;
}
.fieldWidth {
  display: inline-block;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
/deep/.el-textarea textarea {
  min-height: 120px !important;
}
/deep/.el-dialog__header {
  text-align: inherit;
}

.bottom-tabel {
  background-color: #fff;
  padding: 16px 17px 0;
  margin: 0 15px;
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 20px;
}

/deep/.el-select {
  width: 100%;
}
.dialog-footer {
  text-align: right;
  margin-top: 40px;
}
/deep/.el-table .cell {
  overflow: initial;
  text-overflow: inherit;
  white-space: normal;
}
</style>
